// Simple Terminology Configuration for Project Module
// Change this single value to update terminology across the entire application

// Get user preference (you can replace this with your actual user data source)
const getUserPreference = () => {
  // For now, using a simple condition based on user ID
  // Replace this with your actual user data logic
  const userId = 2; // Get this from your auth context, localStorage, or API

  // Define terminology for different user types
  const terminologyMap = {
    1: {
      SINGULAR: "Project",
      PLURAL: "Projects",
      LOWER_SINGULAR: "project",
      LOWER_PLURAL: "projects",
      POSSESSIVE: "Project's",
    },
    2: {
      SINGULAR: "Contract",
      PLURAL: "Contracts",
      LOWER_SINGULAR: "contract",
      LOWER_PLURAL: "contracts",
      POSSESSIVE: "Contract's",
    },
    // Add more user types as needed
  };

  return terminologyMap[userId] || terminologyMap[2]; // Default to Project
};

export const PROJECT_TERMINOLOGY = getUserPreference();

// Helper function to get terminology
export const getTerminology = () => PROJECT_TERMINOLOGY;

// Helper function to replace terminology in strings
export const replaceTerminology = (text: string) => {
  return text
    .replace(/\bProject\b/g, PROJECT_TERMINOLOGY.SINGULAR)
    .replace(/\bProjects\b/g, PROJECT_TERMINOLOGY.PLURAL)
    .replace(/\bproject\b/g, PROJECT_TERMINOLOGY.LOWER_SINGULAR)
    .replace(/\bprojects\b/g, PROJECT_TERMINOLOGY.LOWER_PLURAL)
    .replace(/\bProject's\b/g, PROJECT_TERMINOLOGY.POSSESSIVE);
};

// Export for easy access
export default PROJECT_TERMINOLOGY;
